export const findMenus = ({ target = undefined, location = undefined }) => ({
  type: 'FIND_MENUS',
  target,
  location
})

export const getMenu = (id) => ({
  type: 'GET_MENU',
  id
})



// WEBPACK FOOTER //
// ./src/actions/menus.js